import { gql } from "@apollo/client";

export const RELATED_CONTENT_SECTION_QUERY = gql`
  fragment RelatedContentSectionQuery on RelatedContentRecord {
    articleTag {
      id
    }
    officeTag {
      ... on ServiceRecord {
        id
      }
      ... on ExpertiseRecord {
        id
      }
    }
  }
`;
